import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

/** This window's tabs grouped by site, to jump to, close or summarize. Extension only. */
export default defineWidget({
  type: "kourai.tabs",
  version: 1,
  title: "Open tabs",
  description: "This window's tabs, by site",
  sizes: ["m", "l", "w", "xl"],
  defaultSize: "l",
  surfaces: ["newtab"],
  data: "none",
  permissions: ["tabs"],
  max: 1,
  config: z.object({}),
  load: () => import("./tabs-widget"),
});
